module.exports = __webpack_public_path__ + "img/icon2.1edf28e9.png";